module.exports = __webpack_public_path__ + "img/kx5200-1.fdf36fdf.png";